import { createContext, FC, useContext, useState } from 'react';

export const GlobalSearchContext = createContext<{
  visibility: boolean;
  setVisibility: (any) => void;
} | null>(null);

export const useGlobalSearchContext = () => {
  const context = useContext(GlobalSearchContext);

  if (!context) {
    throw new Error('No data available');
  }

  return context;
};

export const GlobalSearchContextProvider: FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const [visibility, setVisibility] = useState(false);

  return (
    <GlobalSearchContext.Provider value={{ visibility, setVisibility }}>
      {children}
    </GlobalSearchContext.Provider>
  );
};
